import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const PhoneIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.916 12.4128C15.8559 12.3528 12.5432 10.4128 12.4331 10.3628C12.323 10.3128 12.2129 10.2828 12.1128 10.2828C11.9627 10.2828 11.7725 10.3928 11.5423 10.6028C11.3121 10.8228 10.6015 11.7928 10.3914 12.0028C10.1812 12.2228 10.011 12.3228 9.87092 12.3228C9.80086 12.3228 9.72079 12.3028 9.62071 12.2628C9.52062 12.2228 8.45973 11.6828 6.25788 9.74284C4.05603 7.81284 3.76579 6.54284 3.75578 6.19284C3.75578 6.05284 3.86587 5.88284 4.07605 5.67284C4.29623 5.46284 4.52643 5.26284 4.77664 5.07284C5.02685 4.88284 5.26705 4.67284 5.47722 4.45284C5.69741 4.22284 5.79749 4.03284 5.79749 3.88284C5.79749 3.77284 5.76747 3.67284 5.71743 3.56284C5.66738 3.46284 3.6657 0.15284 3.59564 0.0828402C3.44552 -0.0671598 2.85502 0.00284024 2.55477 0.16284C0.162761 1.46284 -0.0273989 3.20284 0.00262637 3.89284C0.04266 4.60284 0.493038 8.35284 4.16612 11.8428C8.72996 16.1728 11.9026 16.0028 12.1128 16.0028C12.8034 16.0028 14.9352 15.6228 15.8359 13.4528C15.966 13.1328 16.0861 12.5828 15.916 12.4128Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default PhoneIcon;
